import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var QuickLRU = /*#__PURE__*/function (_Map, _Symbol$iterator, _Symbol$toStringTag) {
  _inherits(QuickLRU, _Map);
  var _super = _createSuper(QuickLRU);
  function QuickLRU() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, QuickLRU);
    _this = _super.call(this);
    if (!(options.maxSize && options.maxSize > 0)) {
      throw new TypeError('`maxSize` must be a number greater than 0');
    }
    if (typeof options.maxAge === 'number' && options.maxAge === 0) {
      throw new TypeError('`maxAge` must be a number greater than 0');
    }

    // TODO: Use private class fields when ESLint supports them.
    _this.maxSize = options.maxSize;
    _this.maxAge = options.maxAge || Number.POSITIVE_INFINITY;
    _this.onEviction = options.onEviction;
    _this.cache = new Map();
    _this.oldCache = new Map();
    _this._size = 0;
    return _this;
  }

  // TODO: Use private class methods when targeting Node.js 16.
  _createClass(QuickLRU, [{
    key: "_emitEvictions",
    value: function _emitEvictions(cache) {
      if (typeof this.onEviction !== 'function') {
        return;
      }
      var _iterator = _createForOfIteratorHelper(cache),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            item = _step$value[1];
          this.onEviction(key, item.value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_deleteIfExpired",
    value: function _deleteIfExpired(key, item) {
      if (typeof item.expiry === 'number' && item.expiry <= Date.now()) {
        if (typeof this.onEviction === 'function') {
          this.onEviction(key, item.value);
        }
        return this.delete(key);
      }
      return false;
    }
  }, {
    key: "_getOrDeleteIfExpired",
    value: function _getOrDeleteIfExpired(key, item) {
      var deleted = this._deleteIfExpired(key, item);
      if (deleted === false) {
        return item.value;
      }
    }
  }, {
    key: "_getItemValue",
    value: function _getItemValue(key, item) {
      return item.expiry ? this._getOrDeleteIfExpired(key, item) : item.value;
    }
  }, {
    key: "_peek",
    value: function _peek(key, cache) {
      var item = cache.get(key);
      return this._getItemValue(key, item);
    }
  }, {
    key: "_set",
    value: function _set(key, value) {
      this.cache.set(key, value);
      this._size++;
      if (this._size >= this.maxSize) {
        this._size = 0;
        this._emitEvictions(this.oldCache);
        this.oldCache = this.cache;
        this.cache = new Map();
      }
    }
  }, {
    key: "_moveToRecent",
    value: function _moveToRecent(key, item) {
      this.oldCache.delete(key);
      this._set(key, item);
    }
  }, {
    key: "_entriesAscending",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function _entriesAscending() {
      var _iterator2, _step2, item, _item, key, value, deleted, _iterator3, _step3, _item2, _item3, _key, _value, _deleted;
      return _regeneratorRuntime.wrap(function _entriesAscending$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _iterator2 = _createForOfIteratorHelper(this.oldCache);
            _context.prev = 1;
            _iterator2.s();
          case 3:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 13;
              break;
            }
            item = _step2.value;
            _item = _slicedToArray(item, 2), key = _item[0], value = _item[1];
            if (this.cache.has(key)) {
              _context.next = 11;
              break;
            }
            deleted = this._deleteIfExpired(key, value);
            if (!(deleted === false)) {
              _context.next = 11;
              break;
            }
            _context.next = 11;
            return item;
          case 11:
            _context.next = 3;
            break;
          case 13:
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](1);
            _iterator2.e(_context.t0);
          case 18:
            _context.prev = 18;
            _iterator2.f();
            return _context.finish(18);
          case 21:
            _iterator3 = _createForOfIteratorHelper(this.cache);
            _context.prev = 22;
            _iterator3.s();
          case 24:
            if ((_step3 = _iterator3.n()).done) {
              _context.next = 33;
              break;
            }
            _item2 = _step3.value;
            _item3 = _slicedToArray(_item2, 2), _key = _item3[0], _value = _item3[1];
            _deleted = this._deleteIfExpired(_key, _value);
            if (!(_deleted === false)) {
              _context.next = 31;
              break;
            }
            _context.next = 31;
            return _item2;
          case 31:
            _context.next = 24;
            break;
          case 33:
            _context.next = 38;
            break;
          case 35:
            _context.prev = 35;
            _context.t1 = _context["catch"](22);
            _iterator3.e(_context.t1);
          case 38:
            _context.prev = 38;
            _iterator3.f();
            return _context.finish(38);
          case 41:
          case "end":
            return _context.stop();
        }
      }, _entriesAscending, this, [[1, 15, 18, 21], [22, 35, 38, 41]]);
    })
  }, {
    key: "get",
    value: function get(key) {
      if (this.cache.has(key)) {
        var item = this.cache.get(key);
        return this._getItemValue(key, item);
      }
      if (this.oldCache.has(key)) {
        var _item4 = this.oldCache.get(key);
        if (this._deleteIfExpired(key, _item4) === false) {
          this._moveToRecent(key, _item4);
          return _item4.value;
        }
      }
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$maxAge = _ref.maxAge,
        maxAge = _ref$maxAge === void 0 ? this.maxAge : _ref$maxAge;
      var expiry = typeof maxAge === 'number' && maxAge !== Number.POSITIVE_INFINITY ? Date.now() + maxAge : undefined;
      if (this.cache.has(key)) {
        this.cache.set(key, {
          value: value,
          expiry: expiry
        });
      } else {
        this._set(key, {
          value: value,
          expiry: expiry
        });
      }
    }
  }, {
    key: "has",
    value: function has(key) {
      if (this.cache.has(key)) {
        return !this._deleteIfExpired(key, this.cache.get(key));
      }
      if (this.oldCache.has(key)) {
        return !this._deleteIfExpired(key, this.oldCache.get(key));
      }
      return false;
    }
  }, {
    key: "peek",
    value: function peek(key) {
      if (this.cache.has(key)) {
        return this._peek(key, this.cache);
      }
      if (this.oldCache.has(key)) {
        return this._peek(key, this.oldCache);
      }
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var deleted = this.cache.delete(key);
      if (deleted) {
        this._size--;
      }
      return this.oldCache.delete(key) || deleted;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.cache.clear();
      this.oldCache.clear();
      this._size = 0;
    }
  }, {
    key: "resize",
    value: function resize(newSize) {
      if (!(newSize && newSize > 0)) {
        throw new TypeError('`maxSize` must be a number greater than 0');
      }
      var items = _toConsumableArray(this._entriesAscending());
      var removeCount = items.length - newSize;
      if (removeCount < 0) {
        this.cache = new Map(items);
        this.oldCache = new Map();
        this._size = items.length;
      } else {
        if (removeCount > 0) {
          this._emitEvictions(items.slice(0, removeCount));
        }
        this.oldCache = new Map(items.slice(removeCount));
        this.cache = new Map();
        this._size = 0;
      }
      this.maxSize = newSize;
    }
  }, {
    key: "keys",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function keys() {
      var _iterator4, _step4, _step4$value, key;
      return _regeneratorRuntime.wrap(function keys$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _iterator4 = _createForOfIteratorHelper(this);
            _context2.prev = 1;
            _iterator4.s();
          case 3:
            if ((_step4 = _iterator4.n()).done) {
              _context2.next = 9;
              break;
            }
            _step4$value = _slicedToArray(_step4.value, 1), key = _step4$value[0];
            _context2.next = 7;
            return key;
          case 7:
            _context2.next = 3;
            break;
          case 9:
            _context2.next = 14;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            _iterator4.e(_context2.t0);
          case 14:
            _context2.prev = 14;
            _iterator4.f();
            return _context2.finish(14);
          case 17:
          case "end":
            return _context2.stop();
        }
      }, keys, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "values",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function values() {
      var _iterator5, _step5, _step5$value, value;
      return _regeneratorRuntime.wrap(function values$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _iterator5 = _createForOfIteratorHelper(this);
            _context3.prev = 1;
            _iterator5.s();
          case 3:
            if ((_step5 = _iterator5.n()).done) {
              _context3.next = 9;
              break;
            }
            _step5$value = _slicedToArray(_step5.value, 2), value = _step5$value[1];
            _context3.next = 7;
            return value;
          case 7:
            _context3.next = 3;
            break;
          case 9:
            _context3.next = 14;
            break;
          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](1);
            _iterator5.e(_context3.t0);
          case 14:
            _context3.prev = 14;
            _iterator5.f();
            return _context3.finish(14);
          case 17:
          case "end":
            return _context3.stop();
        }
      }, values, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      var _iterator6, _step6, item, _item5, key, value, deleted, _iterator7, _step7, _item6, _item7, _key2, _value2, _deleted2;
      return _regeneratorRuntime.wrap(function value$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _iterator6 = _createForOfIteratorHelper(this.cache);
            _context4.prev = 1;
            _iterator6.s();
          case 3:
            if ((_step6 = _iterator6.n()).done) {
              _context4.next = 12;
              break;
            }
            item = _step6.value;
            _item5 = _slicedToArray(item, 2), key = _item5[0], value = _item5[1];
            deleted = this._deleteIfExpired(key, value);
            if (!(deleted === false)) {
              _context4.next = 10;
              break;
            }
            _context4.next = 10;
            return [key, value.value];
          case 10:
            _context4.next = 3;
            break;
          case 12:
            _context4.next = 17;
            break;
          case 14:
            _context4.prev = 14;
            _context4.t0 = _context4["catch"](1);
            _iterator6.e(_context4.t0);
          case 17:
            _context4.prev = 17;
            _iterator6.f();
            return _context4.finish(17);
          case 20:
            _iterator7 = _createForOfIteratorHelper(this.oldCache);
            _context4.prev = 21;
            _iterator7.s();
          case 23:
            if ((_step7 = _iterator7.n()).done) {
              _context4.next = 33;
              break;
            }
            _item6 = _step7.value;
            _item7 = _slicedToArray(_item6, 2), _key2 = _item7[0], _value2 = _item7[1];
            if (this.cache.has(_key2)) {
              _context4.next = 31;
              break;
            }
            _deleted2 = this._deleteIfExpired(_key2, _value2);
            if (!(_deleted2 === false)) {
              _context4.next = 31;
              break;
            }
            _context4.next = 31;
            return [_key2, _value2.value];
          case 31:
            _context4.next = 23;
            break;
          case 33:
            _context4.next = 38;
            break;
          case 35:
            _context4.prev = 35;
            _context4.t1 = _context4["catch"](21);
            _iterator7.e(_context4.t1);
          case 38:
            _context4.prev = 38;
            _iterator7.f();
            return _context4.finish(38);
          case 41:
          case "end":
            return _context4.stop();
        }
      }, value, this, [[1, 14, 17, 20], [21, 35, 38, 41]]);
    })
  }, {
    key: "entriesDescending",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function entriesDescending() {
      var items, i, item, _item8, key, value, deleted, _i, _item9, _item10, _key3, _value3, _deleted3;
      return _regeneratorRuntime.wrap(function entriesDescending$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            items = _toConsumableArray(this.cache);
            i = items.length - 1;
          case 2:
            if (!(i >= 0)) {
              _context5.next = 12;
              break;
            }
            item = items[i];
            _item8 = _slicedToArray(item, 2), key = _item8[0], value = _item8[1];
            deleted = this._deleteIfExpired(key, value);
            if (!(deleted === false)) {
              _context5.next = 9;
              break;
            }
            _context5.next = 9;
            return [key, value.value];
          case 9:
            --i;
            _context5.next = 2;
            break;
          case 12:
            items = _toConsumableArray(this.oldCache);
            _i = items.length - 1;
          case 14:
            if (!(_i >= 0)) {
              _context5.next = 25;
              break;
            }
            _item9 = items[_i];
            _item10 = _slicedToArray(_item9, 2), _key3 = _item10[0], _value3 = _item10[1];
            if (this.cache.has(_key3)) {
              _context5.next = 22;
              break;
            }
            _deleted3 = this._deleteIfExpired(_key3, _value3);
            if (!(_deleted3 === false)) {
              _context5.next = 22;
              break;
            }
            _context5.next = 22;
            return [_key3, _value3.value];
          case 22:
            --_i;
            _context5.next = 14;
            break;
          case 25:
          case "end":
            return _context5.stop();
        }
      }, entriesDescending, this);
    })
  }, {
    key: "entriesAscending",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function entriesAscending() {
      var _iterator8, _step8, _step8$value, key, value;
      return _regeneratorRuntime.wrap(function entriesAscending$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _iterator8 = _createForOfIteratorHelper(this._entriesAscending());
            _context6.prev = 1;
            _iterator8.s();
          case 3:
            if ((_step8 = _iterator8.n()).done) {
              _context6.next = 9;
              break;
            }
            _step8$value = _slicedToArray(_step8.value, 2), key = _step8$value[0], value = _step8$value[1];
            _context6.next = 7;
            return [key, value.value];
          case 7:
            _context6.next = 3;
            break;
          case 9:
            _context6.next = 14;
            break;
          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6["catch"](1);
            _iterator8.e(_context6.t0);
          case 14:
            _context6.prev = 14;
            _iterator8.f();
            return _context6.finish(14);
          case 17:
          case "end":
            return _context6.stop();
        }
      }, entriesAscending, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "size",
    get: function get() {
      if (!this._size) {
        return this.oldCache.size;
      }
      var oldCacheSize = 0;
      var _iterator9 = _createForOfIteratorHelper(this.oldCache.keys()),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var key = _step9.value;
          if (!this.cache.has(key)) {
            oldCacheSize++;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return Math.min(this._size + oldCacheSize, this.maxSize);
    }
  }, {
    key: "entries",
    value: function entries() {
      return this.entriesAscending();
    }
  }, {
    key: "forEach",
    value: function forEach(callbackFunction) {
      var thisArgument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var _iterator10 = _createForOfIteratorHelper(this.entriesAscending()),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _step10$value = _slicedToArray(_step10.value, 2),
            key = _step10$value[0],
            value = _step10$value[1];
          callbackFunction.call(thisArgument, value, key, this);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }, {
    key: _Symbol$toStringTag,
    get: function get() {
      return JSON.stringify(_toConsumableArray(this.entriesAscending()));
    }
  }]);
  return QuickLRU;
}( /*#__PURE__*/_wrapNativeSuper(Map), Symbol.iterator, Symbol.toStringTag);
export { QuickLRU as default };